import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import config from '../../config/setup';
import api from '../../services/api';
import './VersionCheckBanner.css';

const VersionCheckBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [serverVersion, setServerVersion] = useState(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const clientVersion = config.app.version;
        
        // Set timeout for version check (5 seconds)
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('Version check timeout')), 5000)
        );
        
        const versionCheckPromise = api.get('/api/config/version');
        
        const serverResponse = await Promise.race([versionCheckPromise, timeoutPromise]);
        const serverVersion = serverResponse.data?.version;
        
        if (serverVersion && serverVersion !== clientVersion) {
          // Version mismatch - show banner
          console.log(`Version mismatch detected. Client: ${clientVersion}, Server: ${serverVersion}`);
          setServerVersion(serverVersion);
          setShowBanner(true);
        }
      } catch (error) {
        // If version check fails (network error, timeout, etc.), allow user to proceed
        console.warn('Version check failed, allowing user to proceed:', error.message);
      } finally {
        setIsChecking(false);
      }
    };

    checkVersion();
  }, []);

  const handleRefresh = () => {
    // Force hard refresh to get latest version
    window.location.href = window.location.href;
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="version-check-banner">
      <div className="version-check-banner-content">
        <div className="version-check-banner-message">
          <span className="version-check-banner-icon">🔄</span>
          <span className="version-check-banner-text">
            A new version is available (v{serverVersion}). Please refresh to get the latest features and improvements.
          </span>
        </div>
        <Button
          variant="primary"
          onClick={handleRefresh}
          className="version-check-banner-button"
        >
          Refresh Now
        </Button>
      </div>
    </div>
  );
};

export default VersionCheckBanner;

